const IMAGES = {
    "misc": [
        // require("@fae/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-attack.png"),
        // require("@fae/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-support.png"),
        // require("@fae/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-reposition.png"),
        // require("@fae/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-harvest.png"),
        // require("@fae/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-kindle.png"),
    ],
    "faces": {
        // "human": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.human.png"),
        // "wolf": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.wolf.png"),
        // "fox": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.fox.orange.png"),
        // "white-fox": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.fox.png"),
        // "bunny": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.bunny.png"),
        // "boar": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.boar.png"),
        // "imp": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.imp.png"),
        // "devil": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.devil.png"),
        // "devilscream": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.devil.scream.png"),
        // "knight": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.knight.png"),
        // "skull": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.skull.png"),
        // "goblin": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.goblin.png"),
        // "hobgoblin": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.hobgoblin.png"),
        // "kobold": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.kobold.png"),
        // "dwarf": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.dwarf.png"),
        // "archdwarf": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.archdwarf.png"),
        // "orc": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.orc.png"),
        // "lich": require("@fae/source/assets/images/frog-tactics/stage/units/parts/head.lich.png"),
    },
    "bodies": {
        // "good": require("@fae/source/assets/images/frog-tactics/stage/units/parts/body.good.png"),
        // "bad": require("@fae/source/assets/images/frog-tactics/stage/units/parts/body.bad.png"),
        // "imp": require("@fae/source/assets/images/frog-tactics/stage/units/parts/body.imp.png"),
        // "none": require("@fae/source/assets/images/frog-tactics/stage/units/parts/body.none.png"),
        // "neutral": require("@fae/source/assets/images/frog-tactics/stage/units/parts/body.none.png"),
        // "devil": require("@fae/source/assets/images/frog-tactics/stage/units/parts/body.devil.png"),
    },
    "weapons": {
        // ?
    },
    "portraits": {
        // ?
    },
    "decals": {
        // "red-helmet": require("@fae/source/assets/images/frog-tactics/stage/units/parts/decal.helmet.red.png"),
        // "blue-helmet": require("@fae/source/assets/images/frog-tactics/stage/units/parts/decal.helmet.blue.png"),
        // "green-helmet": require("@fae/source/assets/images/frog-tactics/stage/units/parts/decal.helmet.green.png"),
        // "grimrawr": require("@fae/source/assets/images/dungeon-tactics/grimrawr.png"),
    },
    "images": {
        "red": require("@fae/source/assets/images/frog-tactics/stage/units/red.png"),
        "red-tetromino": require("@fae/source/assets/images/frog-tactics/stage/units/red-tetromino.png"),
        // "prince": require("@fae/source/assets/images/teach-tactics/mapsprite-PRINCE.png"),
    },
    "arrow": {
        "north-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-end.png"),
        "north-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-start.png"),
        "south-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-end.png"),
        "south-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-start.png"),
        "east-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/east-end.png"),
        "east-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/east-start.png"),
        "west-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/west-end.png"),
        "west-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/west-start.png"),
        "north-west": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-west.png"),
        "north-east": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-east.png"),
        "south-west": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-west.png"),
        "south-east": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-east.png"),
        "east-west": require("@fae/source/assets/images/hero-tactics-ii/arrow/east-west.png"),
        "north-south": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-south.png"),
    },
}

import games from "./games/index.js"
Object.values(games).forEach((game) => {
    if(game.images != undefined) {
        Object.keys(game.images).forEach((imageType) => {
            if(IMAGES[imageType] == undefined) {
                IMAGES[imageType] = {}
            }
            IMAGES[imageType] = {
                ...IMAGES[imageType],
                ...game.images[imageType]
            }
        })
    }
})

export default IMAGES
